import { useCallback, useEffect, useState } from "react";

import {
  getMcpApiKeyApi,
  listMcpTracesApi,
} from "../../../services/api/mcpApi";
import {
  MCP_DETAILS_LABELS,
  mcpErrorMessage,
  normalizeApiKey,
  normalizeTraceList,
} from "../../HelperFunction/mcpHelpers";

const idle = { data: null, loading: false, error: "" };

export default function useMcpKeyDetails({ userId, keyId }) {
  const [details, setDetails] = useState(idle);
  const [traces, setTraces] = useState({ ...idle, data: [] });

  const loadDetails = useCallback(async () => {
    if (!userId || !keyId) return;
    setDetails({ data: null, loading: true, error: "" });

    try {
      const response = await getMcpApiKeyApi(userId, keyId);
      setDetails({ data: normalizeApiKey(response.data), loading: false, error: "" });
    } catch (err) {
      setDetails({
        data: null,
        loading: false,
        error: mcpErrorMessage(err, MCP_DETAILS_LABELS.detailsFailed),
      });
    }
  }, [userId, keyId]);

  const loadTraces = useCallback(async () => {
    if (!userId || !keyId) return;
    setTraces({ data: [], loading: true, error: "" });

    try {
      const response = await listMcpTracesApi(userId, keyId);
      setTraces({ data: normalizeTraceList(response.data), loading: false, error: "" });
    } catch (err) {
      setTraces({
        data: [],
        loading: false,
        error: mcpErrorMessage(err, MCP_DETAILS_LABELS.tracesFailed),
      });
    }
  }, [userId, keyId]);

  useEffect(() => {
    if (keyId) {
      loadDetails();
      loadTraces();
    } else {
      setDetails(idle);
      setTraces({ ...idle, data: [] });
    }
  }, [keyId, loadDetails, loadTraces]);

  return { details, traces, reloadDetails: loadDetails, reloadTraces: loadTraces };
}
